import { render, staticRenderFns } from "./FormDos.vue?vue&type=template&id=b8c75d24&scoped=true&"
import script from "./FormDos.vue?vue&type=script&lang=js&"
export * from "./FormDos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c75d24",
  null
  
)

export default component.exports